module.exports = __webpack_public_path__ + "0e5b5a5456c5b914141b338a87d91a6d.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/12_column_small_x1/public/history/8.jpg
// module id = 308
// module chunks = 0